import dayjs from 'dayjs';

import { api } from 'config';

import { Response } from 'types';

import { subscriptionStatusTypes } from 'utils/subscription/statusTypes';

import { ActiveLicense } from './types';

export async function getActiveLicense(options: { storeUuid?: string }) {
  if (!options.storeUuid) return null;

  const result = await api.get<Response<ActiveLicense>>('/v1/stores/info/', {
    params: {
      store_uuid: options.storeUuid,
    },
  });

  const responseData = result.data.data.license;
  const responseMenuPublication = result.data.data.menuPublication;
  const { wizardCompleted } = result.data.data;

  const isBlockingStatus =
    responseData?.status === subscriptionStatusTypes.UNAVAILABLE ||
    responseData?.status === subscriptionStatusTypes.PAYMENT_REQUIRED;

  // Web access lasts until webCutoffDate, plus any extra days granted. Both dates have to be present:
  // dayjs(undefined) is "now", which would hand a valid window to a store that has none.
  const hasCutoffDates = Boolean(responseData?.webCutoffDate) && Boolean(responseData?.serverDate);
  const webAccessDeadline = dayjs(responseData?.webCutoffDate).add(responseData?.extensionConnect ?? 0, 'day');
  const isWithinWebCutoff =
    isBlockingStatus && hasCutoffDates && dayjs(responseData?.serverDate).isBefore(webAccessDeadline);

  // Access only needs the deadline. The banner announces a granted extension, so it also needs the
  // extra days to exist: with zero of them the deadline is the ordinary cutoff, not an extension.
  const licenseExtesionAllowed = isWithinWebCutoff && responseData?.extensionConnect > 0;

  const licenseStatus = isWithinWebCutoff ? subscriptionStatusTypes.AVAILABLE : responseData?.status;

  const response = {
    ...responseData,
    status: licenseStatus,
    licenseExtesionAllowed,
    menuPublicationState: responseMenuPublication.state,
    wizardCompleted,
  };

  return response;
}
